import React from 'react';

const PHOTOS = [
  { file: 'DSC_0619', width: 1440, height: 1012, caption: 'Para compartir el antojo', alt: 'Tres choripanes con chips de plátano, salsas y bebidas' },
  { file: 'DSC_0769', width: 960, height: 640, caption: 'Cada bocado cuenta', alt: 'Choripán con vegetales, salsa y chips de plátano' },
  { file: 'DSC_0745', width: 960, height: 640, caption: 'Choripán y chips', alt: 'Choripán en pan redondo con vegetales, chips de plátano y salsa' },
  { file: 'DSC_0676', width: 960, height: 640, caption: 'El combo completo', alt: 'Choripán con chips de plátano, salsa y una bebida embotellada' }
];

export const FoodGallery = () => (
  <section aria-labelledby="food-gallery-title" className="max-w-2xl mx-auto px-6 pt-6">
    <div className="mb-3">
      <h2 id="food-gallery-title" className="text-lg font-black text-slate-900 dark:text-white">El antojo, en fotos</h2>
      <p className="text-xs text-slate-500 dark:text-slate-400">Choripanes, chips y combos de nuestra cocina.</p>
    </div>
    <div tabIndex={0} aria-label="Galería de comida; desplázate para ver las cuatro fotos" className="flex gap-3 overflow-x-auto pb-2 snap-x snap-mandatory rounded-2xl focus:outline-none focus:ring-2 focus:ring-primary">
      {PHOTOS.map((photo, index) => (
        <figure key={photo.file} className="w-56 sm:w-64 shrink-0 snap-start overflow-hidden rounded-2xl bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800">
          <img
            src={`${process.env.PUBLIC_URL}/food/${photo.file}.jpg`}
            alt={photo.alt}
            width={photo.width}
            height={photo.height}
            loading={index === 0 ? 'eager' : 'lazy'}
            decoding="async"
            className="h-36 sm:h-44 w-full object-cover"
          />
          <figcaption className="px-3 py-2 text-xs font-bold text-slate-700 dark:text-slate-300">{photo.caption}</figcaption>
        </figure>
      ))}
    </div>
  </section>
);
